import AppActionTypes from './types';
import { action } from 'typesafe-actions';

export const setTheme = (theme: string) =>
  action(AppActionTypes.SET_APP_THEME, theme);

export const setAppLang = (language: string) =>
  action(AppActionTypes.SET_APP_LANGUAGE, language);

export const setHeaderPanelExpand = (req: any) =>
  action(AppActionTypes.SET_HEADER_PANEL_EXPAND, req);

export const setPivateTeamBaseMap = (req: {
  userId: number;
  baseMap: string;
}) => action(AppActionTypes.SET_PRIVATE_TEAMBASE_MAP, req);
